"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const utils_1 = require("../utils/utils");
const useDelayedClosed = (isOpen, ignoreDelayedClose) => {
    const [isClosed, setIsClosed] = (0, react_1.useState)(!isOpen);
    (0, react_1.useEffect)(() => {
        if (ignoreDelayedClose) {
            return undefined;
        }
        if (isOpen) {
            setIsClosed(false);
            return undefined;
        }
        const timeoutId = setTimeout(() => { setIsClosed(true); }, utils_1.MODAL_CLOSE_TIMEOUT);
        return () => clearTimeout(timeoutId);
    }, [ignoreDelayedClose, isOpen]);
    return isClosed;
};
exports.default = useDelayedClosed;
//# sourceMappingURL=useDelayedClose.js.map